<template>
  <v-container>
    <v-card
      class="mx-auto ma-xs-1"
      max-width="265"
    >
      <v-row align="center">
        <v-col cols="auto" class="mr-0 pr-0">
          <v-card-subtitle>Created by</v-card-subtitle>
        </v-col>
        <v-col cols="auto" class="ml-0 pl-0">
          <a href="https://www.fridaynightstripes.com" target="_blank">
            <v-img
              max-width="50" 
              src="../assets/FNS.jpg"
            >
            </v-img>
          </a>
        </v-col>
        <v-col cols="auto">
          <v-row align="center">
            <v-col class="ma-0 pa-0">
              <a href="https://podcasts.google.com/?feed=aHR0cHM6Ly9mZWVkcy50cmFuc2lzdG9yLmZtL2ZyaWRheS1uaWdodC1zdHJpcGVz">
                <v-img max-width="70" src="../assets/GooglePlay.png" />
              </a>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="ma-0 pa-0">
              <a href="https://open.spotify.com/show/2yLEQ39jqOtuxnu5fFpxVY">
                <v-img max-width="70" src="../assets/Spotify.png" />
              </a>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col class="ma-0 pa-0">
              <a href="https://itunes.apple.com/us/podcast/friday-night-stripes/id1425156055">
                <v-img max-width="70" src="../assets/iTunes.png" />
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "FNSAd"
}
</script>